export const WarehouseEndpoints = {
  LIST: '/api/admin/logistics/warehouses',
  GET: '/api/admin/logistics/warehouses/:id',
  CREATE: '/api/admin/logistics/warehouses',
  UPDATE: '/api/admin/logistics/warehouses/:id',
};
